import cntl from "cntl";
import PropTypes from "prop-types";
import { useMemo, useState } from "react";
import { COLOR, SIZE } from "../constants";
import SectionContent from "./SectionContent";
import SectionItem from "./SectionItem";

const propTypes = {
  theme: PropTypes.oneOf(["", COLOR.dark, COLOR.grey, COLOR.light, COLOR.primary, COLOR.primary_light]),
};

function FeatureSimpleIcons04({ items, theme, content }) {
  const [bgColor, setBgColor] = useState("");

  const wrapperCn = () => cntl`
    ${bgColor}
  `;

  const containerCn = () => cntl`
    container
    mx-auto
    px-4 md:px-8 py-16 md:py-24
    grid
    grid-cols-1
    lg:grid-cols-3
    gap-y-12
    lg:gap-x-16
  `;

  const columnsWrapperCn = () => cntl`
    grid
    grid-cols-1
    md:grid-cols-2
    gap-y-10
    gap-x-0
    md:gap-x-16
    max:gap-y-8
    col-span-2
  `;

  const itemCn = () => cntl`
    flex 
    flex-col 
    gap-y-14 
    w-fit
  `;

  useMemo(() => {
    switch (theme) {
      case "dark":
        setBgColor("bg-grey-800");
        break;
      case "grey":
        setBgColor("bg-grey-50");
        break;
      case "primary":
        setBgColor("bg-primary-800");
        break;
      case "primaryLight":
        setBgColor("bg-primary-50");
        break;
      case "light":
        setBgColor("bg-white");
        break;
      default:
        break;
    }
  }, [theme]);

  return (
    <div className={wrapperCn()}>
      <div className={containerCn()}>
        <SectionContent {...content} size={SIZE.sm} />
        <div className={columnsWrapperCn()}>
          {items?.map(({ text, title }, index) => {
            return (
              <div className={itemCn()} key={`simple-icon-item-${index}`} >
                <SectionItem theme={theme} title={title} text={text} />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

FeatureSimpleIcons04.prototype = propTypes;
export default FeatureSimpleIcons04;
